module.exports = __webpack_public_path__ + "static/media/Sketch5.d6b5184c.jpg";